import styled from 'styled-components'

import Avatar from '../Avatar'
import ActionButton from '../ActionButton'
import Link from '../Link'
import Icon from '../Icon'

export const AdsAuthorCard = styled.div`
  background-color: ${({ theme }) => theme.colors.pureWhite};
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
  border: 1px solid ${({ theme }) => theme.colors.greyContour};
  border-radius: 2rem;
  padding: 2.4rem 3rem;
`

export const AuthorAvatar = styled(Avatar)`
  flex-direction: row-reverse;
  justify-content: flex-end;

  > div {
    flex-direction: column;
    gap: 0;
    text-align: left;

    span:first-child {
      ${({ theme }) => theme.textStyles.montserratTextBaseBold};
    }
    span:last-child {
      ${({ theme }) => theme.textStyles.montserratTextBase};
    }
    span:only-child {
      ${({ theme }) => theme.textStyles.montserratTextBaseBold};
    }
  }

  .ImageContainer {
    width: 6rem;
    height: 6rem;
    border-radius: initial;
  }

  img {
    object-fit: cover;
  }
`

export const Description = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  color: ${({ theme }) => theme.colors.taupeGray};
`

export const Button = styled(ActionButton)``

export const AddressLabel = styled.p`
  ${({ theme }) => theme.textStyles.bebasTextBase};
  color: ${({ theme }) => theme.colors.taupeGray};
`

export const AddressWrapper = styled.div``

export const Address = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  color: ${({ theme }) => theme.colors.taupeGray};
`

export const ItinaryLink = styled(Link)`
  ${({ theme }) => theme.textStyles.montserratXs};
  color: ${({ theme }) => theme.colors.bluePrimary};
  text-decoration: underline;
`

export const AdsLink = styled(Link)`
  color: ${({ theme }) => theme.colors.pinkButton};
  ${({ theme }) => theme.textStyles.montserratTextBaseBold};
  display: flex;
  align-items: center;
  margin-top: 0.7rem;

  &:hover {
    svg {
      transform: translateX(5px);
    }
  }
`

export const AdsNumber = styled.span`
  ${({ theme }) => theme.textStyles.vujahdayTextBase};
  color: ${({ theme }) => theme.colors.pureBlack};
  margin-left: 0.5rem;
`

export const ChevonSvg = styled(Icon)`
  margin-left: auto;
  transform: translateX(0);
  transition: transform 320ms ease-in-out;
`

export const Separator = styled.div`
  background-image: repeating-linear-gradient(
      0deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      180deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      270deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    );
  background-size: 0, 0, 2px 100%, 100% 2px;
  background-position: 0 0, 0 0, 100% 0, 0 100%;
  background-repeat: no-repeat;
  height: 0.2rem;
  width: 100%;
`
